import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private _requestService: RequestService) { }

  listWorksHome(data): Observable<any> {
    const url = `work/ListWorksOfHome`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  listQuantityWorks(): Observable<any> {
    const url = `work/ListQuantityWorksOfHome`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  markWorksSeen(idObra): Observable<any> {
    const url = `work/${idObra}/set-seen`;
    return this._requestService.requestMethod(url, 'POST', true);
  }

   listResponsables(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null
    );
  }

  getTaskSummary(periodoDias: number = 30): Observable<any> {
    return this._requestService.requestMethod(
      `work/Schedule/Summary?periodoDias=${periodoDias}`,
      'GET',
      true,
      null
    );
  }
 
  getNewOpportunities(diasFiltro: number = 7): Observable<any> {
    return this._requestService.requestMethod(
      `work/Opportunities/New?diasFiltro=${diasFiltro}`,
      'GET',
      true,
      null
    );
  }
 
  getNetworkStatus(diasFiltro: number = 7, diasSemInteracao: number = 10): Observable<any> {
    return this._requestService.requestMethod(
      `work/Network/Status?diasFiltro=${diasFiltro}&diasSemInteracao=${diasSemInteracao}`,
      'GET',
      true,
      null
    );
  }

}
